var bts = angular.module("bootstrap.member", []);
bts.value("portal", "member");
bts.run(["link", "navigation", "brand", "sessionData", "modal", "hook", "$cookies", "services", "$timeout", function (link, navigation, brand, sessionData, modal, hook, $cookies, services, $timeout) {
	if (location.href.indexOf("mobile=true") > 0) {
		$cookies.put("mobileUser", "true");
		// FIXME:  {path: "/"}
	}

	var mSiteNav = function (id) {
		return "javascript:try {window.opener.nav.goSite('" + id + "');window.close();}catch(err){alert('The mobile window has unexpectedly closed!');}";
	};

	var openFindMedicareProviderModal = function () {
		modal.close();
		$timeout(function () {
			modal.open({
				classes: "findMedicareProviderPopup",
				template: require('modals/findMedicareProviderPopup.html'),
				controller: ["$scope", "brand", function ($scope, brand) {
					$scope.medicareUrl = (brand.current.sharedBrandCode == "mincr") ? "/rbsmbl/x-services/public/sapphire/find-a-doctor/mmincr" : "/login/#/find-a-doctor?medicare=yes";
					$scope.nonmedicareUrl = (brand.current.sharedBrandCode == "mincr") ? "/rbsmbl/x-services/public/sapphire/find-a-doctor/mincr" : "/login/#/find-a-doctor";
					$scope.target = "_blank";
					$scope.medicareUrlfad = function () {
						window.open($scope.medicareUrl, '_blank');
						modal.close();
					};
					$scope.nonmedicareUrlfad = function () {
						window.open($scope.nonmedicareUrl, '_blank');
						modal.close();
					};

				}]
			});
		}, 100);
	};

	/*ND_WELLNESS*/

	var nd_wellnessProgramsIndicator = "false";
	var findDoctorModal = function () {
		modal.open({
			classes: "findDoctorModal",
			template: require('articles/findProviderModal.html'),
			controller: ["$scope", "brand", "sessionData", function ($scope, brand, sessionData) {
				$scope.brandCheck = brand.current.sharedBrandCode;

				$scope.eyeSlide = $scope.brandCheck === "ndbcbs" || $scope.brandCheck === "wybcbs";
				var isVitalsLive = (sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER.VITALS_LIVE) ? sessionData.appConfig.PROVIDER.VITALS_LIVE.booleanValue : false;
				switch (brand.current.sharedBrandCode) {

					case "hmbcbs":
						$scope.content = {
							"modalTitle": "Highmark has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"/chmptl/chm/jsp/providerSearchLink.do",
								"target": "_blank",
								"showMedicarePopup": true,
								"findMedicarePopup": openFindMedicareProviderModal
							},
							"findPharmacy": {
								"maPreferredHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKMedDPref\" target=\"_blank\">Medicare Preferred Value Network Pharmacy</a>",
								"seventeenHeader": "For Plans Effective January 01, 2017",
								"maStandardHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKPlPartnr\" target=\"_blank\">Medicare Network Pharmacy</a>",
								"premierPharmPrevHref": "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
								"premierPharmCurrentHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
								"focusedPharmHref": "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
								"medicarePharmHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy network; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findEyeCare": {},
							"findDentist": {
								"advantageHref": "https://secure.ucci.com/tp2fad/?network=070&lang=en&brandid=HM1-",
								"advantagePlusHref": "https://secure.ucci.com/tp2fad/?network=074&lang=en&brandid=HM1-",
								"allianceHref": "https://secure.ucci.com/tp2fad/?network=2&lang=en&brandid=HM1-"
							},
							"findDrug": {
								"preReform": {
									"progressiveDrugHref": "http://client.formularynavigator.com/clients/highmark/commercial_20111001.html",
									"comprehensiveDrugHref": "http://client.formularynavigator.com/clients/highmark/commercial.html",
									"medicareDrugHref": "http://client.formularynavigator.com/clients/hm/default.html",
									"eliteDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6589177812"
								},
								"postReform": {
									"progressiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=1791332925",
									"comprehensiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=1788724309",
									"essentialDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6571849149"
								}
							}
						};
						break;
					case "hmbcbswv":
						$scope.content = {
							"modalTitle": "Highmark has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"https://provdir.highmarkbcbswv.com/?brand=HWV",
								"target": "_blank",
								"showMedicarePopup": true,
								"findMedicarePopup": openFindMedicareProviderModal
							},
							"findPharmacy": {
								"maPreferredHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKMedDPref\" target=\"_blank\">Medicare Preferred Value Network Pharmacy</a>",
								"seventeenHeader": "For Plans Effective January 01, 2017",
								"maStandardHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKPlPartnr\" target=\"_blank\">Medicare Network Pharmacy</a>",
								"premierPharmPrevHref": "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
								"premierPharmCurrentHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
								"nationalPlusNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy network; pharmacy participation can vary depending on the pharmacy network selected for your plan design."


							},
							"findEyeCare": {},
							"findDentist": {},
							"findDrug": {

								"postReform": {
									"progressiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=4909431197",
									"comprehensiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=4906449921",
									"essentialDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6571849149"
								}
							}
						};
						break;
					case "hmbcbsde":
						$scope.content = {
							"modalTitle": "Highmark has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"/chmptl/chm/jsp/providerSearchLink.do",
								"target": "_blank",
								"showMedicarePopup": true,
								"findMedicarePopup": openFindMedicareProviderModal
							},
							"findPharmacy": {
								"seventeenHeader": "For Plans Effective January 01, 2017",
								"premierPharmPrevHref": "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
								"premierPharmCurrentHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
								"focusedPharmHref": "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
								"medicarePharmHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy network; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findEyeCare": {},
							"findDentist": {},
							"findDrug": {
								"preReform": {
									"comprehensiveDrugHref": "https://client.formularynavigator.com/Search.aspx?siteCode=1546534148",
									"eliteDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6589177812"
								},
								"postReform": {
									"comprehensiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=7597050967"
								}
							}
						};
						break;
					case "hbs":
						$scope.content = {
							"modalTitle": "Highmark has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"/chmptl/chm/jsp/providerSearchLink.do",
								"target": "_blank",
								"showMedicarePopup": true,
								"findMedicarePopup": openFindMedicareProviderModal
							},
							"findPharmacy": {
								"maPreferredHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKMedDPref\" target=\"_blank\">Medicare Preferred Value Network Pharmacy</a>",
								"seventeenHeader": "For Plans Effective January 01, 2017",
								"maStandardHeaderContent": "Locate a <a href=\"https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKPlPartnr\" target=\"_blank\">Medicare Network Pharmacy</a>",
								"premierPharmPrevHref": "http://www.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold",
								"premierPharmCurrentHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/pl.jsp?memtype=hmkgold3",
								"focusedPharmHref": "http://www.medco.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEFOCUSPPOLKUP&memtype=openenrollment",
								"medicarePharmHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"nationalPlusNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"medicareNetworkHref": "https://host1.medcohealth.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=hmk",
								"preferredMedicareContent": "Blue Rx PDP Complete, Blue Rx PDP Plus, Community Blue Medicare, HMO Signature and Security Blue HMO Value Rx",
								"preferredMedicareHref": "www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKMedDPref",
								"standardMedicareHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKPlPartnr",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy network; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findEyeCare": {},
							"findDentist": {
								"advantageHref": "https://secure.ucci.com/tp2fad/?network=070&lang=en&brandid=HM2-",
								"advantagePlusHref": "https://secure.ucci.com/tp2fad/?network=074&lang=en&brandid=HM2-",
								"allianceHref": "https://secure.ucci.com/tp2fad/?network=2&lang=en&brandid=HM2-"
							},
							"findDrug": {
								"preReform": {
									"progressiveDrugHref": "http://client.formularynavigator.com/clients/highmark/commercial_20111001.html",
									"comprehensiveDrugHref": "http://client.formularynavigator.com/clients/highmark/commercial.html",
									"medicareDrugHref": "http://client.formularynavigator.com/clients/hm/default.html",
									"eliteDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6589177812"
								},
								"postReform": {
									"progressiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=1791332925",
									"comprehensiveDrugPostReformHref": "http://client.formularynavigator.com/Search.aspx?siteCode=1788724309",
									"essentialDrugPostReformHref": "https://client.formularynavigator.com/Search.aspx?siteCode=6571849149"
								}
							}
						};
						break;
					case "mincr":
					case "9014":
						$scope.content = {
							"modalTitle": "Blue Cross and Blue Shield of Minnesota and Blue Plus have health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"/pvd/",
								"target": "_blank",
								"showMedicarePopup": isVitalsLive,
								"findMedicarePopup": openFindMedicareProviderModal,
								"newWindow": isVitalsLive
							},
							"findPharmacy": {
								"pharmacyHeader": "Want to find a pharmacy near where you live or work? See your benefit booklet for your pharmacy network.",
								"findAPharmacyHref": "https://www.myprime.com/v/BCBSMN/COMMERCIAL/en/find-pharmacy.html",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy networks; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findDentist": {
								"dentalOverrideContent": "<p>If you have a Blue Cross individual Dental Plan, or Blue Cross Dental Plan through your employer, <a class='find-a-dentist-link-href' href='https://bluecrossmn.com/findadentist' target='_blank'>find dentists here</a></p><p>If you have a Blue Cross Medicare Plan with dental benefits, <a class='find-a-dentist-link-href' href='https://mn.ourdentalcoverage.com/find-a-dentist/?network=304' target='_blank'>find dentists here</a></p>",
								"dentalOverrideFooter": "You will be leaving our website and entering the United Concordia website to view the providers directory. United Concordia is a separate company contracted to provide the dental network of providers for Blue Cross Blue Shield of Minnesota."
							},
							"findDrug": {
								"findDrugHeader": "A drug formulary is a preferred list of drugs that cost you less out-of-pocket. Drugs are listed by brand and generic names. See your benefit booklet for your formulary.",
								"findADrugHref": "https://www.myprime.com/v/BCBSMN/COMMERCIAL/en/find-medicine.html"
							}
						};
						break;
					case "ndbcbs":
						$scope.content = {
							"modalTitle": "Blue Cross Blue Shield of North Dakota has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home",
								"target": "_blank"
							},
							"findPharmacy": {
								"pharmacyHeader": "Want to find a pharmacy near where you live or work? See your benefit booklet for your pharmacy network.",
								"findAPharmacyHref": "https://www.myprime.com/en/find-pharmacy.html",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy networks; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findEyeCare": "<p>If you have a BlueVision plan, search our, <a class='find-a-eyeCare-link-href' href='https://vsp.com/find-eye-doctors.html?id=signature' target='_blank'>vision network</a> for an eye care provider, including a choice of ophthalmologists or optometrists and retailers.</p><p>If you have a preventive eye exam as part of your medical or health plan, please use our <a class='find-a-eyeCare-link-href' href='/find-a-doctor/#/home' target='_blank'>Find a Doctor tool.</a></p>",
							"findDentist": {
								"dentalOverrideContent": "<p>If you have dental benefits, <a class='find-a-dentist-link-href' href='https://nd.ourdentalcoverage.com/find-a-dentist/' target='_blank'>find dentists here.</a></p><p>For some oral or dental surgery, <a class='find-a-dentist-link-href' href='/find-a-doctor/#/home' target='_blank'>find doctors here.</a></p><p>(Check your plan information to see what may be covered.)</p>",
								"dentalOverrideFooter": "You will be leaving our website and entering the United Concordia website to view the providers directory. United Concordia is a separate company contracted to provide the dental network of providers for Blue Cross Blue Shield of North Dakota."
							},
							"findDrug": {
								"findDrugHeader": "A drug formulary is a preferred list of drugs that cost you less out-of-pocket. Drugs are listed by brand and generic names. See your benefit booklet for your formulary.",
								"findADrugHref": " https://www.myprime.com/en/medicines.html#find-medicine "
							}
						};
						if (isVitalsLive) {
							$scope.content.findDoctor.url = "/rbsmbl/x-services/public/sapphire/find-a-doctor/ndbcbs";
							$scope.content.findEyeCare = "<p>If you have a BlueVision plan, search our, <a class='find-a-eyeCare-link-href' href='https://vsp.com/find-eye-doctors.html?id=signature' target='_blank'>vision network</a> for an eye care provider, including a choice of ophthalmologists or optometrists and retailers.</p><p>If you have a preventive eye exam as part of your medical or health plan, please use our <a class='find-a-eyeCare-link-href' href='/rbsmbl/x-services/public/sapphire/find-a-doctor/ndbcbs' target='_blank'>Find a Doctor tool.</a></p>";
							$scope.content.findDentist.dentalOverrideContent = "<p>If you have dental benefits, <a class='find-a-dentist-link-href' href='https://nd.ourdentalcoverage.com/find-a-dentist/' target='_blank'>find dentists here.</a></p><p>For some oral or dental surgery, <a class='find-a-dentist-link-href' href='/rbsmbl/x-services/public/sapphire/find-a-doctor/ndbcbs' target='_blank'>find doctors here.</a></p><p>(Check your plan information to see what may be covered.)</p>";
						}
						break;
					case "wybcbs":
						$scope.content = {
							"modalTitle": "Blue Cross Blue Shield of Wyoming has health care providers that are right for you.",
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home",
								"target": "_blank"
							},
							"findPharmacy": {
								"pharmacyHeader": "Want to find a pharmacy near where you live or work? See your benefit booklet for your pharmacy network.",
								"findAPharmacyHref": " ",

								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy networks; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findEyeCare": "<p>Search for an <a class='find-a-eyeCare-link-href' href='/login/#/vision-provider-search' target='_blank'>eye care provider</a> including ophthalmologists, optometrists and retailers.</p>",
							"findDentist": {
								"dentalOverrideContent": "<p><a class='find-a-dentist-link-href' href='https://wy.ourdentalcoverage.com/find-a-dentist/' target='_blank'>Find </a> a network dentist or dental specialist.</p>",
								"dentalOverrideFooter": "You will be leaving our website and entering the United Concordia website to view the providers directory. United Concordia is a separate company contracted to provide the dental network of providers for Blue Cross Blue Shield of Wyoming."
							},
							"findDrug": {
								"findDrugHeader": "A drug formulary is a preferred list of drugs that cost you less out-of-pocket. Drugs are listed by brand and generic names. See your benefit booklet for your formulary.",
								"findADrugHref": " "
							}
						};
						if (isVitalsLive) {
							$scope.content.findDoctor.url = "/rbsmbl/x-services/public/sapphire/find-a-doctor/wybcbs";
						}
						break;
					case "hhic":
					case "fl":
					case "lou":
					case "az":
					case "la":
					case "neb":
					case "exc":
					case "regbcbs":
					case "regbs":
					case "wi":
					case "hz":
					case "inac":
					case "mn":
					case "pp":
					case "ub":
						$scope.content = {
							"findDoctor": {
								"url": (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.NEW_PVD_HREF && sessionData.appConfig.SPLASH.NEW_PVD_HREF.booleanValue && sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue) ? sessionData.appConfig.SPLASH.NEW_PVD_HREF.overrideValue : "/find-a-doctor/#/home", //"https://provdir.mybenefitshome.com",
								"target": "_blank"
							},
							"findPharmacy": {
								"seventeenHeader": "For Plans Effective January 01, 2017",
								"premierPharmPrevHref": "http://www.medcohealth.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=OEP2012PPOLKUP&memtype=openenrollment",
								"premierPharmCurrentHref": "http://www.medcohealth.com/medco/consumer/mybenefits/clientPl.jsp?globNav=0&memberNo=1234567899&memtype=openenrollment",
								"futureScriptsPharmHref": "https://www.futurescripts.com/FutureScripts/",
								"nationalPlusNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPREMIEROB",
								"nationalNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBPremier",
								"advantageNetworkHref": "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKBFocus",
								"pharmacyFooter": "Please note: These pharmacies participate in our standard pharmacy network; pharmacy participation can vary depending on the pharmacy network selected for your plan design."
							},
							"findDentist": {
								"advantageHref": "https://secure.ucci.com/tp2fad/?network=070&lang=en&brandid=HMKB-"
							},
							"findDrug": {
								"sectionHref": "http://client.formularynavigator.com/Search.aspx?siteCode=1158840676"
							}
						};
						break;
				}

				var contentList = {};
				contentList["CHM_SPLASH_FIND_A_DRUG"] = {};
				contentList["CHM_SPLASH_FIND_A_PHARMACY"] = {};
				contentList['MBR_FIND_DENTIST_CONTENT'] = {};
				contentList['MBR_FIND_DENTIST_CONTENT_SMALL'] = {};
				contentList['MBR_FIND_EYE_CARE_PROVIDER_LINK'] = {};

				services.rbsmbl.contentInfo().getContent(contentList, {
					"brand": (brand.current.umsBrandCode || brand.current.sharedBrandCode).toUpperCase()
				}).then(function (response) {
					var listOfProviders = response && response.data && response.data.payload && response.data.payload.contentResponse;
					var findADrugContent = listOfProviders && listOfProviders[0] && listOfProviders[0].value;
					var findAPharmacyContent = listOfProviders && listOfProviders[1] && listOfProviders[1].value;
					if (findADrugContent) {
						$scope.content.findDrug = findADrugContent;
					}
					if (findAPharmacyContent) {
						$scope.content.findPharmacy = findAPharmacyContent;
					}
					var brandVal = $scope.brandCheck;
					if (brandVal === 'hmbcbs' || brandVal === 'hmbcbswv' || brandVal === 'hbs' || brandVal === 'hmbcbsde') {
						var findADentistContent = listOfProviders && listOfProviders[2] && listOfProviders[2].value;
						if (findADentistContent) {
							var dentalOverrideFooter = listOfProviders && listOfProviders[3] && listOfProviders[3].value;
							$scope.content.findDentist = {
								dentalOverrideContent: findADentistContent,
								dentalOverrideFooter: dentalOverrideFooter
							};
						}
						for (var i = 0; i < listOfProviders.length; i++) {
							if (listOfProviders[i].name === "MBR_FIND_EYE_CARE_PROVIDER_LINK") {
								$scope.content.findEyeCare = listOfProviders[i].value;
								break;
							}
						}
					}
				});

				$scope.showFifteenNetworks = new Date().getFullYear() < 2018 ? true : false;
				$scope.showSeventeenNetworks = true;
			}]
		});
	};

	var memberPrePasswordLogInLink = link.set("memberPrePasswordHome", {
		"label": "Log In",
		"url": false,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'mincr', 'pp', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member"
		},
		"filters": [function (item) {
			if (sessionData && sessionData.siteOutage && sessionData.siteOutage.isActive === true) {
				return false;
			}
			return item;
		}]
	});

	var memberPrePasswordRegisterLink = link.set("memberPrePasswordHome", {
		"label": "Register",
		"url": "/login/#/register",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'pp', 'mincr', 'wybcbs', 'idh', 'la'],
			"portal": "member"
		},
		"filters": [function (item) {
			if (sessionData && sessionData.siteOutage && sessionData.siteOutage.isActive === true) {
				return false;
			}
			return item;
		}]
	});
	var memberNDPrePasswordRegisterLink = link.set("memberPrePasswordHome", {
		"label": "Register",
		"url":"/login/#/registration/register",
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member"
		},
		"filters": [function (item) {
			if (sessionData && sessionData.siteOutage && sessionData.siteOutage.isActive === true) {
				return false;
			}
			return item;
		}]
	});
	var memberPrePasswordHomeLink = link.set("memberPrePasswordHome", {
		"label": "Home",
		"url": "/home/",
		"icon": true,
		"mSite": mSiteNav("home"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member"
		}
	});

	var memberPrePasswordPayPremiumLink = link.set("memberPrePasswordPayPremium", {
		"label": "Pay Premium",
		"url": "/billing/guest",
		"mSite": "/billing/guest",
		"newWindow": true,
		"filterData": {
			"brand": [ 'hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'mn', '6011', 'mincr', 'la', 'wybcbs', 'ndbcbs'],
			"portal": "member"
		}
	})

	var memberPrePasswordDiscoverLink = link.set("memberPrePasswordDiscover", {
		"label": "Discover",
		"url": "http://discoverhighmark.com/",
		"mSite": "http://discoverhighmark.com/",
		"newWindow": true,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'idh', 'la'],
			"portal": "member"
		}
	});

	var memberPrePasswordShopLink = link.set("memberPrePasswordShop", {
		"label": "Shop",
		"url": "http://shop.highmark.com/",
		"mSite": "http://shop.highmark.com/",
		"newWindow": true,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'idh', 'la'],
			"portal": "member"
		}
	});

	var memberPrePasswordShopmnLink = link.set("memberPrePasswordShopmn", {
		"label": "Shop Plans",
		"url": "https://shop.bluecrossmnonline.com",
		"mSite": "https://shop.bluecrossmnonline.com",
		"newWindow": true,
		"filterData": {
			"brand": ['mincr'],
			"portal": "member"
		}
	});

	var memberPrePasswordCustomerServicendLink = link.set("memberPrePasswordCustomerServicend", {
		"label": "CUSTOMER SERVICE",
		"url": "https://www.bcbsnd.com/customer-service-overview",
		"mSite": "https://www.bcbsnd.com/customer-service-overview",
		"newWindow": true,
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member"
		}
	});

	var memberPrePasswordPrimaryPolicyndLink = link.set("memberPrePasswordPrivacyPolicynd", {
		"label": "Privacy & Legal",
		"url": "https://www.bcbsnd.com/privacy/policy",
		"mSite": "https://www.bcbsnd.com/privacy/policy",
		"newWindow": true,
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member"
		}
	});

	var memberPrePasswordndNoSurprisesActLink = link.set("memberPrePasswordNoSurprisesActnd", {
		"label": "No Surprises Act",
		"url": "https://www.bcbsnd.com/privacy-legal/no-surprises-act",
		"mSite": "https://www.bcbsnd.com/privacy-legal/no-surprises-act",
		"newWindow": true,
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member"
		}
	});

	var memberPrePasswordShopwyLink = link.set("memberPrePasswordShopwy", {
		"label": "Shop Plans",
		"url": "https://shop.yourwyoblue.com",
		"mSite": "https://shop.yourwyoblue.com",
		"newWindow": true,
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member"
		}
	});

	if (brand.current.isVitalsActive && !(brand.current.sharedBrandCode === "wybcbs" || brand.current.sharedBrandCode === "ndbcbs" || brand.current.sharedBrandCode === "mincr")) {
		var memberPrePasswordFindDoctorLink = link.set("memberPrePasswordFindDoctor", {
			"label": "Find a Doctor or Pharmacy",
			"onClick": findDoctorModal,
			"url": "/find-a-doctor/#/home",
			"filterData": {
				"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
				"portal": "member"
			},
			"filters": [function (item) {

				var isVitalsLive = (sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER.VITALS_LIVE) ? sessionData.appConfig.PROVIDER.VITALS_LIVE.booleanValue : false;
				if (!isVitalsLive) {
					item.url = "";
				} else if (brand == 'hmbcbs' || brand == 'hmbcbswv' || brand == 'hbs' || brand == 'hmbcbsde') {
					item.url = "";
				} else {
					item.onClick = null;
				}
				return item;
			}]
		});
	} else {
		var memberPrePasswordFindDoctorLink = link.set("memberPrePasswordFindDoctor", {
			"label": "Find a Doctor or RX",
			"onClick": findDoctorModal,
			"filterData": {
				"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
				"portal": "member"
			}
		});
	}

	var memberPrePasswordLiveHealthyLink = link.set("memberPrePasswordLiveHealthy", {
		"label": "Wellbeing",
		"url": "https://www.bluecrossmn.com/healthy/public/personal/home/livehealthy/lh-health-wellbeing",
		"mSite": "https://www.bluecrossmn.com/healthy/public/personal/home/livehealthy/lh-health-wellbeing",
		"newWindow": true,
		"filterData": {
			"brand": ['mincr'],
			"portal": "member"
		}
	});

	var memberPrePasswordWellnesswyLink = link.set("memberPrePasswordWellness", {
		"label": "Wellness",
		"url": "https://www.bcbswy.com/wellness/",
		"mSite": "https://www.bcbswy.com/wellness/",
		"newWindow": true,
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member"
		}
	});

	var memberPrePasswordMedicareLink = link.set("memberPrePasswordMedicare", {
		"label": "Medicare",
		"url": "https://medicare.highmark.com",
		"mSite": "https://medicare.highmark.com",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'idh', 'la'],
			"portal": "member"
		}
	});

	var memberPrePasswordMedicareMNLink = link.set("memberPrePasswordMedicare", {
		"label": "Medicare",
		"url": "https://bcbsminnesota1{env}.destinationrx.com/PC/2022/Shopping/Home",
		"mSite": "https://bcbsminnesota1{env}.destinationrx.com/PC/2022/Shopping/Home",
		"newWindow": true,
		"filterData": {
			"brand": ['mincr'],
			"portal": "member"
		},
		"filters": [function (item) {
			var env = window.location.host.split(".")[0]
			item.url = (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.booleanValue && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.overrideValue) ? sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.overrideValue : "https://bcbsminnesota1{env}.destinationrx.com/PC/2022/Shopping/Home";
			item.mSite = item.url;

			item.url = item.url.replace("{env}", (env === 'www') ? "" : ".staging")
			return item;
		}]
	});

	var memberPrePasswordMedicareWYLink = link.set("memberPrePasswordMedicare", {
		"label": "Medicare",
		"url": "https://medicare.yourwyoblue.com",
		"mSite": "https://medicare.yourwyoblue.com",
		"newWindow": true,
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member"
		}
		// "filters": [function(item) {
		//     item.url = (sessionData && sessionData.appConfig && sessionData.appConfig.SPLASH && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.booleanValue && sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.overrideValue) ? sessionData.appConfig.SPLASH.TEMP_MEDICARE_URL.overrideValue : "https://shop.yourwyoblue.com/medicare/";
		//     item.mSite = item.url;
		//     return item;
		// }]
	});

	var memberPostPasswordHomeLink = link.set("memberPostPasswordHome", {
		"label": "Home",
		"rootState": "home",
		"url": "/mbr/#!/landing",
		"icon": true,
		"mSite": mSiteNav("home"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNHomeLink = link.set("memberPostPasswordHome", {
		"label": "Home",
		"rootState": "home",
		"url": "/member/home",
		"icon": true,
		"mSite": mSiteNav("home"),
		"filterData": {
			"brand": ['mincr'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidHomeLink = link.set("memberPostPasswordHome", {
		"label": "Home",
		"rootState": "home",
		"url": "/medicaid/mbr/#!/landing",
		"icon": true,
		"mSite": mSiteNav("home"),
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});


	var memberPostPasswordEbillLink = link.set("memberPostPasswordEbill", {
		"label": "Pay Premium",
		"rootState": "payPremium",
		"url": "/login/#/ebill",
		"mSite": false,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', '6011', 'mincr', 'la', 'wybcbs'],
			"portal": "member",
			"postPassword": true
		},
		"filters": [function (item) {
			services.rbsmbl.ebillUserExists().getTargetUrl(brand).then(
				function (response) {
					if (response) {
						var unregistered = response &&
							response.data &&
							response.data.payload &&
							response.data.payload.ebillAccountexists === "N";
						if (unregistered) {
							item.url = '/login/#/ebill';
							return item;
						}
						else {
							item.url = '/billing/invoices';
							return item;
						}
					}
				},
				function (err) {
					item.url = '/login/#/ebill';
					return item;
				}

			);
			return true;
		}
		]
	});

	var memberPostPasswordSpendingLink = link.set("memberPostPasswordSpending", {
		"label": "Spending",
		"rootState": "spending",
		"url": "/spa/#/spendingSummary",
		"mSite": "/spa/#/spendingSummary",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'la'],
			"portal": "member",
			"postPassword": true
		},
		"state": {
			"disabled": false,
			"message": "This section is not available right now.",
			"disableCheck": function () {
				return sessionData.spendingAccountBlackoutIndicator;
			}
		}
	});


	var memberPostPasswordCoverageLink = link.set("memberPostPasswordCoverage", {
		"label": "Coverage",
		"rootState": "coverage",
		"url": "/mbr/#!/coverage/coverage-summary",
		"mSite": false,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidCoverageLink = link.set("memberPostPasswordCoverage", {
		"label": "Coverage",
		"rootState": "coverage",
		"url": "/medicaid/mbr/#!/coverage/coverage-summary",
		"mSite": false,
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordClaimsAndSpendingLink = link.set("memberPostPasswordClaimsAndSpending", {
		"label": "Claims & Spending",
		"rootState": "claimsAndSpending",
		"url": "/login/#/claims-and-spending",
		"mSite": "/login/#/claims-and-spending",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordClaimsLink = link.set("memberPostPasswordClaims", {
		"label": "Claims",
		"rootState": "claims",
		"url": "/login/#/claims/activitySummary",
		"mSite": "/login/#/claims/activitySummary",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidClaimsLink = link.set("memberPostPasswordClaims", {
		"label": "Claims",
		"rootState": "claims",
		"url": "/medicaid/login/#/claims/activitySummary",
		"mSite": "/medicaid/login/#/claims/activitySummary",
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordFindDoctorLink = link.set("memberPostPasswordFindDoctor", {
		"label": "Find a Doctor",
		"rootState": "finder",
		"url": "/login/#/finder",
		"mSite": mSiteNav("finddoctor"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidFindDoctorLink = link.set("memberPostPasswordFindDoctor", {
		"label": "Find a Doctor",
		"rootState": "finder",
		"url": "/medicaid/login/#/finder",
		"mSite": mSiteNav("finddoctor"),
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordPrescriptionsLink = link.set("memberPostPasswordPrescriptions", {
		"label": "Prescriptions",
		"rootState": "prescriptions",
		"url": "/login/#/prescriptions",
		"mSite": false,
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidPrescriptionsLink = link.set("memberPostPasswordPrescriptions", {
		"label": "Prescriptions",
		"rootState": "prescriptions",
		"url": "/medicaid/login/#/prescriptions",
		"mSite": false,
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordWellnessLinkND = link.set("memberPostPasswordWellness", {
		"label": "Wellness",
		"rootState": "wellness",
		"url": "/login/#/wellness",
		"mSite": mSiteNav("healthwellness"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'wybcbs', 'idh', 'ndbcbs', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordWellnessLink = link.set("memberPostPasswordWellness", {
		"label": "Wellness",
		"rootState": "wellness",
		"url": "/login/#/wellness",
		"mSite": mSiteNav("healthwellness"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidWellnessLink = link.set("memberPostPasswordWellness", {
		"label": "Wellness",
		"rootState": "wellness",
		"url": "/medicaid/login/#/wellness",
		"mSite": mSiteNav("healthwellness"),
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});
	var memberPostPasswordNDFormsResourcesLink = link.set("memberPostPasswordFormsResources", {
		"label": "Forms & Resources",
		"rootState": "formsAndResources",
		"url": "/login/#/claims/educational-materials",
		"mSite": mSiteNav("forms-and-resources"),
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordAccountLink = link.set("memberPostPasswordAccount", {
		"label": "Your Account",
		"url": false,
		"mSite": false,
		"collapsed": "mobileTabletCollapsed",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', '9014', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordAccountSettingsLink = link.set("memberPostPasswordAccountSettings", {
		"label": "Account Settings",
		"url": "/mbr/#!/account/membership-information",
		"mSite": mSiteNav("accountsettings"),
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMNMedicaidAccountSettingsLink = link.set("memberPostPasswordAccountSettings", {
		"label": "Account Settings",
		"url": "/medicaid/mbr/#!/account/membership-information",
		"mSite": mSiteNav("accountsettings"),
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMessageCenterLink = link.set("memberPostPasswordMessageCenter", {
		"label": "Message Center",
		"url": "/msg/",
		"mSite": "/msg/",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordVSBPLink = link.set("memberPostPasswordVSBP", {
		"label": "View Site By Plan",
		"url": '/login/#/vsbp',
		"mSite": false, // "/chmptl/chm/jsp/emktSeekEntitlementSelection.do", // FIXME
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'mn', 'mincr', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		},
		"filters": [function (item) {
			if ($cookies.get('mbrViewSiteByPlanSelection') == "true") {
				if ((sessionData && sessionData.appConfig && sessionData.appConfig.MEMBER_UI && sessionData.appConfig.MEMBER_UI.showVsbpMar2016 && sessionData.appConfig.MEMBER_UI.showVsbpMar2016.booleanValue) && (sessionData.appConfig.MEMBER_UI.showVsbpMar2016.booleanValue == true)) {
					item.url = '/login/#/vsbp';
					return item;
				}
				return true;
			}
			return false;
		}]
	});

	var memberPostPasswordMNMedicaidVSBPLink = link.set("memberPostPasswordVSBP", {
		"label": "View Site By Plan",
		"url": '/medicaid/login/#/vsbp',
		"mSite": false, // "/chmptl/chm/jsp/emktSeekEntitlementSelection.do", // FIXME
		"filterData": {
			"brand": ['9014'],
			"portal": "member",
			"postPassword": true
		},
		"filters": [function (item) {
			if ($cookies.get('mbrViewSiteByPlanSelection') == "true") {
				if ((sessionData && sessionData.appConfig && sessionData.appConfig.MEMBER_UI && sessionData.appConfig.MEMBER_UI.showVsbpMar2016 && sessionData.appConfig.MEMBER_UI.showVsbpMar2016.booleanValue) && (sessionData.appConfig.MEMBER_UI.showVsbpMar2016.booleanValue == true)) {
					item.url = '/medicaid/login/#/vsbp';
					return item;
				}
				return true;
			}
			return false;
		}]
	});

	var memberPostPasswordCustomersLink = link.set("memberPostPasswordCustomers", {
		"label": "For Our Customers",
		"url": false,
		"mSite": false,
		"collapsed": "mobileTabletCollapsed",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', "ub", 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', '9014', 'ndbcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMembersLink = link.set("memberPostPasswordMembers", {
		"label": "FOR OUR MEMBERS",
		"url": false,
		"mSite": false,
		"collapsed": "mobileTabletCollapsed",
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordFindAnAgentLink = link.set("memberPostPasswordFindAnAgent", {
		"url": "https://www.bcbswy.com/insurance/",
		"newWindow": true,
		"label": "Find an Agent",
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordMemberCentersLink = link.set("memberPostPasswordMemberCenters", {
		"url": "https://www.bcbswy.com/contact/office_locations.html",
		"newWindow": true,
		"label": "Member Centers",
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordBCBSWYLink = link.set("memberPostPasswordBCBSWY", {
		"url": "https://www.bcbswy.com/",
		"newWindow": true,
		"label": "BCBSWY.com",
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordContactUsFooterLink = link.set("memberPostPasswordcontactusfooter", {
		"url": "/msg/#!/contact-us",
		"newWindow": false,
		"label": "Contact Us",
		"filterData": {
			"brand": ['wybcbs'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordAboutLink = link.set("memberPostPasswordAbout", {
		"url": "https://www.highmark.com/hmk2/about/vision/index.shtml",
		"newWindow": true,
		"label": "About Highmark",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbsde', 'hhic'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordAboutMNLink = link.set("memberPostPasswordAboutMN", {
		"url": "https://www.bluecrossmn.com/about-blue-cross",
		"newWindow": true,
		"label": "About Us",
		"filterData": {
			"brand": ['mincr', '9014'],
			"portal": "member",
			"postPassword": true
		}
	});
	var memberPostPasswordAboutNDLink = link.set("memberPostPasswordAboutND", {
		"url": "https://www.bcbsnd.com/about/company",
		"newWindow": true,
		"label": "About Us",
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member",
			"postPassword": true
		}
	});
	var memberPostPasswordContactUsLink = link.set("memberPostPasswordContactUs", {
		"url": "/msg/#!/contact-us",
		"label": "Contact Us",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'ndbcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPostPasswordFAQSLink = link.set("memberPostPasswordFAQS", {
		"url": "/msg/#!/contact-us",
		"label": "FAQs",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', '9014', 'ndbcbs', 'wybcbs', 'idh', 'la'],
			"portal": "member",
			"postPassword": true
		}
	});
	var memberPostPasswordFAQSNDLink = link.set("memberPostPasswordFAQS", {
		"url": "https://www.bcbsnd.com/customer-service/faq",
		"label": "FAQs",
		"filterData": {
			"brand": ['ndbcbs'],
			"portal": "member",
			"postPassword": true
		}
	});
	var memberPostPasswordFormsLibraryLink = link.set("memberPostPasswordFormsLibrary", {
		"url": "/login/#/forms",
		"label": "Forms Library",
		"filterData": {
			"brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp'],
			"portal": "member",
			"postPassword": true
		}
	});

	var memberPrePasswordAdditionalLink = link.set("memberPrePasswordAdditional", {
		"label": "Additional Links",
		"url": false,
		"mSite": false,
		"filterData": {
			"brand": ['*'],
			"portal": "member"
		},
		"links": [
			link.set("memberPrePasswordAdditional1", { "url": "/login/#/customerService/contact-us", "label": "Customer Service", "newWindow": true, "filterData": { "brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'mincr', 'idh', 'la'] } }),
			link.set("memberPrePasswordAdditional2", { "url": "/login/#/customerService/contact-us", "label": "Customer Service", "newWindow": true, "filterData": { "brand": ['pp'] } }),
			link.set("memberPrePasswordAdditional3", { "url": "https://www.independencenationalalliance.com/login/#/customerService/contact-us", "label": "Customer Service", "newWindow": true, "filterData": { "brand": ['inac'] } }),

			link.set("memberPrePasswordAdditional4", { "url": "http://www.highmarkdirect.com", "label": "Find a Direct Store", "newWindow": true, "filterData": { "brand": ['hmbcbs', 'hbs'] } }),
			link.set("memberPrePasswordAdditional5", { "url": "https://www.bluecrossmn.com/store", "label": "Retail Store", "newWindow": true, "filterData": { "brand": ['mincr'] } }),

			link.set("memberPrePasswordAdditional6", { "url": "https://www.highmark.com/hmk2/about/vision/index.shtml", "label": "About Highmark", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmsb", "hmbcbswv", "hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional7", { "url": "https://www.bluecrossmn.com/about-blue-cross", "label": "About Us", "newWindow": true, "filterData": { "brand": ['mincr'] } }),

			link.set("memberPrePasswordAdditional8", { "url": "https://www.highmark.com/privacy.html", "label": "Privacy Policy", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmsb"] } }),
			link.set("memberPrePasswordAdditional9", { "url": "https://www.highmark.com/privacy.html", "label": "Privacy Policy", "newWindow": true, "filterData": { "brand": ["hmbcbswv"] } }),
			link.set("memberPrePasswordAdditional10", { "url": "https://www.highmark.com/privacy.html", "label": "Privacy Policy", "newWindow": true, "filterData": { "brand": ["hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional11", { "url": "https://www.mybenefitshome.com/pdffiles/OnlinePrivacyPolicy_MBH.pdf", "label": "Privacy Policy", "newWindow": true, "filterData": { "brand": ['pp'] } }),
			link.set("memberPrePasswordAdditional11", { "url": "https://www.highmark.com/hmk2/gdpr.shtml", "label": "GDPR", "newWindow": true, "filterData": { "brand": ["hmbcbsde", "hmbcbswv", "ms", "hmbcbs", "hbs"] } }),

			link.set("memberPrePasswordAdditional12", { "url": "https://www.highmark.com/health/professionals/medical-policy/medical-policy-acceptance.html", "label": "Medical Policy", "newWindow": true, "filterData": { "brand": ["hmbcbs"] } }),
			link.set("memberPrePasswordAdditional13", { "url": "/content/dam/highmark/en/highmarkblueshield/member/medicalpolicy/hbs-medical-policy-acceptance.html", "label": "Medical Policy", "newWindow": true, "filterData": { "brand": ["hbs"] } }),
			link.set("memberPrePasswordAdditional14", { "url": "https://www.highmark.com/health/professionals/delaware-commercial-medical-policy/medical-policy-acceptance.html", "label": "Medical Policy", "newWindow": true, "filterData": { "brand": ["hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional15", { "url": "/vk2luv/pages/search.jsp?content=MEDICALPOLICY&context=UNBRANDED&region=ALL&resource=BCBSA&user=PUBLIC", "label": "Medical Policy", "newWindow": true, "filterData": { "brand": ["pp"] } }),
			link.set("memberPrePasswordAdditional16", { "url": "https://www.independencenationalalliance.com/vk2luv/pages/search.jsp?content=MEDICALPOLICY&context=UNBRANDED&region=ALL&resource=BCBSA&user=PUBLIC", "label": "Medical Policy", "newWindow": true, "filterData": { "brand": ["inac"] } }),

			link.set("memberPrePasswordAdditional17", { "url": "/accessibility/accessibility_wpa.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["hmbcbs"] } }),
			link.set("memberPrePasswordAdditional18", { "url": "/accessibility/accessibility_cre.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["hbs", "hmsb"] } }),
			link.set("memberPrePasswordAdditional19", { "url": "/accessibility/accessibility_mbh.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["hmbcbswv"] } }),
			link.set("memberPrePasswordAdditional20", { "url": "/accessibility/accessibility_de.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional21", { "url": "/accessibility/accessibility_mbh.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["pp"] } }),
			link.set("memberPrePasswordAdditional22", { "url": "https://www.independencenationalalliance.com/accessibility/accessibility_mbh.html", "label": "Accessibility", "newWindow": true, "filterData": { "brand": ["inac"] } }),

			link.set("memberPrePasswordAdditional23", { "url": "https://www.highmark.com/hmk2/texting.shtml", "label": "SMS Texting", "newWindow": true, "filterData": { "brand": ['hmbcbs', 'hbs', 'hmbcbswv', 'hhic', 'fl', 'lou', 'az', 'ub', 'neb', 'exc', 'regbcbs', 'regbs', 'wi', 'hz', 'inac', 'hmbcbsde', 'ibccr', 'ibcah', 'mn', 'idh', 'la'] } }),
			link.set("memberPrePasswordAdditional24", { "url": "https://www.mybenefitshome.com/pdffiles/sms.pdf", "label": "SMS Texting", "newWindow": true, "filterData": { "brand": ['pp'] } }),
			link.set("memberPrePasswordAdditional25", { "url": "https://www.independencenationalalliance.com/texting.html", "label": "SMS Texting", "newWindow": true, "filterData": { "brand": ['inac'] } }),

			link.set("memberPrePasswordAdditional26", { "url": "https://www.highmark.com/hmk2/terms.shtml", "label": "Terms of Service", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmsb", "hmbcbswv", "hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional27", { "url": "https://www.mybenefitshome.com/pdffiles/terms_of_service.pdf", "label": "Terms of Service", "newWindow": true, "filterData": { "brand": ['pp'] } }),

			link.set("memberPrePasswordAdditional28", { "url": "https://www.highmark.com/hmk2/fraud/index.shtml", "label": "Fraud Prevention", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmsb", "hmbcbswv", "hmbcbsde"] } }),
			//link.set("memberPrePasswordAdditional29", { "url": "https://www.highmark.com/hmk2/hipaa/index.shtml", "label": "HIPAA", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmsb", "hmbcbswv", "hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional30", { "onClick": findDoctorModal, "label": "Find a Doctor or Rx", "filterData": { "brand": ["pp"] } }),

			link.set("memberPrePasswordAdditional35", { "url": "https://www.bcbswy.com/insurance/", "label": "Find an Agent", "newWindow": true, "filterData": { "brand": ['wybcbs'] } }),
			link.set("memberPrePasswordAdditional36", { "url": "https://www.bcbswy.com/contact/office_locations.html", "label": "Member Centers", "newWindow": true, "filterData": { "brand": ['wybcbs'] } }),
			link.set("memberPrePasswordAdditional37", { "url": "https://www.bcbswy.com/privacy/", "label": "Privacy & Legal", "newWindow": true, "filterData": { "brand": ['wybcbs'] } }),
			link.set("memberPrePasswordAdditional38", { "url": "https://www.bcbswy.com/information/", "label": "Important Info", "newWindow": true, "filterData": { "brand": ['wybcbs'] } }),
			link.set("memberPrePasswordAdditional39", { "url": "https://www.bcbswy.com/", "label": "BCBSWY.com", "newWindow": true, "filterData": { "brand": ['wybcbs'] } }),
			link.set("memberPrePasswordAdditional40", { "url": "/login/#/forms", "label": "Forms Library", "newWindow": false, "filterData": { "brand": ["hmbcbs", "highmarkbcbs", "hbcbs", "pbs", "hbs", "highmarkblueshield", "highmarkbcbswv", "de", "highmarkbcbsde", "hmbcbsde", "ms", "hmbcbswv", "mbh:wv", "pp"] } }),
			link.set("memberPrePasswordAdditional41", { "url": "https://www.highmark.com/no-surprises-act", "label": "No Surprises Act", "newWindow": true, "filterData": { "brand": ["hmbcbs", "hbs", "hmbcbswv", "hmbcbsde"] } }),
			link.set("memberPrePasswordAdditional42", { "url": "https://bluecrossmn.com/nosurprises", "label": "No Surprises Act", "newWindow": true, "filterData": { "brand": ["mincr"] } }),
			link.set("memberPrePasswordAdditional42", { "url": "https://www.cms.gov/nosurprises", "label": "No Surprises Act", "newWindow": true, "filterData": { "brand": ["pp"] } })
		],
		"linkFilters": ["brand", "msite", "postPassword"]
	});

	var changePasswordLink = link.set("changePassword", {
		"label": "Change Password",
		"url": "#/change-password",
		"rootState": "changePassword",
		"filterData": {
			"brand": ["*"],
			"portal": "member",
			"postPassword": true,
			"tempPassword": true
		}
	});

	memberPostPasswordEbillLink.filters.push(function () {
		var fullMemberInfo = sessionData.memberInfo;
		var shouldShow = false;
		var isSubscriber = false;
		var currentPlan = services.rbsmbl.memberInfo().currentMember(sessionData.memberInfo);
		if (sessionData.memberInfo && currentPlan.relationship === "Subscriber") {
			isSubscriber = true;
		}
		if (fullMemberInfo) {
			fullMemberInfo.clientList.forEach(function (client) {
				client.groupList.forEach(function (group) {
					if (group.medicareIndicator == "true" || group.directPayIndicator == "true" && isSubscriber) {
						return shouldShow = true;
					}
				});

				if (shouldShow) {
					return shouldShow;
				}
			});
		}

		return shouldShow;
	});
	var shouldShowClaimsAndSpendingTab = function () {
		
		var claimsAndSpendingMaintenance = (sessionData
			&& sessionData.appConfig
			&& sessionData.appConfig.CLAIMS_AND_SPENDING
			&& sessionData.appConfig.CLAIMS_AND_SPENDING.MAINTENANCE
			&& sessionData.appConfig.CLAIMS_AND_SPENDING.MAINTENANCE.booleanValue);

		//remove-this-condition-once-cmcrst-ub-complete
		var shouldShowClaimsAndSpendingToAll = true;//temporary fix

		// var shouldShowClaimsAndSpendingToAll = (sessionData
		// 	&& sessionData.appConfig
		// 	&& sessionData.appConfig.CLAIMS_AND_SPENDING
		// 	&& sessionData.appConfig.CLAIMS_AND_SPENDING.SHOW_TO_ALL
		// 	&& sessionData.appConfig.CLAIMS_AND_SPENDING.SHOW_TO_ALL.booleanValue);
		var vendorDetails = (sessionData && sessionData.vendorDetails
			? angular.copy(sessionData.vendorDetails)
			: []);

		var today = new Date();

		var claimsAndSpendingBoolean = vendorDetails[0] && vendorDetails[0].claimAndSpending;

		if (claimsAndSpendingMaintenance) {
			return sessionData.isClaimsAndSpending = false;
		} else if (shouldShowClaimsAndSpendingToAll) {
			return sessionData.isClaimsAndSpending = true;
		}

		if (claimsAndSpendingBoolean === true) {
			return sessionData.isClaimsAndSpending = true;
		}

		return sessionData.isClaimsAndSpending = false;
	};

	memberPostPasswordClaimsAndSpendingLink.filters.push(function () {
		//return shouldShowClaimsAndSpendingTab();
		if (!shouldShowClaimsAndSpendingTab()
			|| (sessionData.preEffectuatedValues && sessionData.preEffectuatedValues.isPreEffectuated && sessionData.preEffectuatedValues.preEffectuatedBrandFlag)
		) {
			return false;
		}

		return true;
	});
	memberPostPasswordClaimsLink.filters.push(function () {
		// For IBC, Claims link hidden for blueExtraBasic and blueExtraPlus
		if (sessionData.isBlueExtraBasic
			|| sessionData.isBlueExtraPlus
			|| shouldShowClaimsAndSpendingTab()
			|| (sessionData.preEffectuatedValues && sessionData.preEffectuatedValues.isPreEffectuated && sessionData.preEffectuatedValues.preEffectuatedBrandFlag)
		) {
			return false;
		}

		return true;
	});

	memberPostPasswordSpendingLink.filters.push(function () {
		// blueEdgeDental or Minnesota Medicare - hides Spending link
		//|| sessionData.mnHasSpendingAccount==false mn member has no spending account
		var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();
		if (sessionData.blueEdgeDentalIndv
			|| (sessionData.memberInfo && sessionData.memberInfo.brand.toLowerCase() === 'mincr' && (sessionData.medicareIndicator))
			|| shouldShowClaimsAndSpendingTab()
			|| (sessionData.preEffectuatedValues && sessionData.preEffectuatedValues.isPreEffectuated && sessionData.preEffectuatedValues.preEffectuatedBrandFlag)
			|| (sessionData.memberInfo && sessionData.memberInfo.brand.toLowerCase() === 'ndbcbs' && portalSelectedPlan.isNDMedicaid)
		) {
			return false;
		}
		return true;
	});

	memberPostPasswordFindDoctorLink.filters.push(function () {
		// blueEdgeDental hides FindDoctor link
		if (sessionData.blueEdgeDentalIndv) {
			return false;
		}

		return true;
	});

	memberPostPasswordMessageCenterLink.filters.push(function () {
		if (sessionData.memberInfo) {

			var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(sessionData.memberInfo);
			var milliServerDate = Date.parse(new Date());
			var isActive = false;
			var showLink;
			for (var i = 0; i < portalSelectedPlan.productList.length; i++) {
				var highmarkBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'ms', 'hmbcbsde', 'pp'];
				var millisEndDate = portalSelectedPlan.productList[i].coverageCancelDate !== "" ? Date.parse(portalSelectedPlan.productList[i].coverageCancelDate) : Date.parse(portalSelectedPlan.productList[i].coverageEndDate);

				var isSubscriber = services.rbsmbl.memberInfo().currentMember().relationship == "Subscriber";
				if (isActive == false) {
					isActive = milliServerDate < millisEndDate;
					if (isActive) {
						return true;
					} else {
						if (!isSubscriber &&
							(highmarkBrands.indexOf(sessionData.memberInfo.brand.toLowerCase()) > -1)) {
							showLink = false;
						} else {
							showLink = true;
						}
					}
				}

			}
			return showLink;
		} else {
			return false;
		}


	});

	memberPostPasswordPrescriptionsLink.filters.push(function () {
		// Hide prescriptions link if no drug coverage found
		if (sessionData.memberInfo && sessionData.memberInfo.brand.toLowerCase() === 'mincr') {
			var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();
			var milliServerDate = Date.parse(new Date());
			for (var i = 0; i < portalSelectedPlan.productList.length; i++) {
				if (portalSelectedPlan.productList[i].coverageConBeginDate) {
					var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageConBeginDate);
				} else {
					var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageBeginDate);
				}
				var millisEndDate = Date.parse(portalSelectedPlan.productList[i].coverageEndDate);
				var coverageIsCurrent = false;
				coverageIsCurrent = ((millisBeginDate < milliServerDate) && (milliServerDate < millisEndDate));
				if (coverageIsCurrent && (portalSelectedPlan.productList[i].benefitPlanType === "Drug" || portalSelectedPlan.productList[i].benefitPlanType === "PrescriptionDrug" || portalSelectedPlan.productList[i].drugCoverage === "true")) {
					return true;
				} else {
					return false;
				}
			}
		}
		if (sessionData.memberInfo && sessionData.memberInfo.brand.toLowerCase() === 'ndbcbs' && services.rbsmbl.memberInfo().getPortalSelectedPlan().isNDMedicaid && !sessionData.preEffectuatedValues.isPreEffectuated) {
			return true;
		}
		if ((sessionData.memberInfo && sessionData.memberInfo.brand.toLowerCase() !== 'mincr') && (!sessionData.benefits
			|| sessionData.benefits && !sessionData.benefits.drug
			|| (sessionData.preEffectuatedValues && sessionData.preEffectuatedValues.isPreEffectuated && sessionData.preEffectuatedValues.preEffectuatedBrandFlag))
		) {
			return false;
		} else {
			return true;
		}
	});

	memberPostPasswordMNMedicaidPrescriptionsLink.filters.push(function () {
		// Hide prescriptions link if no drug coverage found
		if (!sessionData.benefits || sessionData.benefits && !sessionData.benefits.drug) {
			return false;
		}
		return true;
	});



	var portalFilter = navigation.setFilter("portal", function (item) {
		return "member" == item.filterData.portal;
	});

	memberPostPasswordAccountLink.links = [memberPostPasswordAccountSettingsLink, memberPostPasswordMNMedicaidAccountSettingsLink, memberPostPasswordMessageCenterLink, memberPostPasswordVSBPLink, memberPostPasswordMNMedicaidVSBPLink];
	memberPostPasswordAccountLink.linkFilters = ["brand", "msite", "postPassword", "portal"];

	memberPostPasswordCustomersLink.links = [memberPostPasswordAboutLink, memberPostPasswordAboutMNLink, memberPostPasswordAboutNDLink, memberPostPasswordContactUsLink, memberPostPasswordFAQSNDLink, memberPostPasswordFormsLibraryLink]; // Removed FAQs link as part of Accessibility remediation and added for ND.
	memberPostPasswordCustomersLink.linkFilters = ["brand", "msite", "postPassword", "portal"];

	memberPostPasswordMembersLink.links = [memberPostPasswordFindAnAgentLink, memberPostPasswordMemberCentersLink, memberPostPasswordContactUsLink, memberPostPasswordContactUsFooterLink, memberPostPasswordBCBSWYLink, memberPostPasswordFormsLibraryLink];
	memberPostPasswordMembersLink.linkFilters = ["brand", "msite", "postPassword", "portal"];

	var postLogoutUrl = navigation.set("postLogoutUrl");
	postLogoutUrl.linkFilters.push("brand", "portal");
	postLogoutUrl.links.push(memberPrePasswordHomeLink);
	var logoLink = navigation.set("logoLink");
	logoLink.linkFilters.push("brand", "postPassword", "portal", "tempPassword");
	logoLink.links.push(memberPrePasswordHomeLink, memberPostPasswordHomeLink, memberPostPasswordMNMedicaidHomeLink, memberPostPasswordMNHomeLink);

	var headerTabs = navigation.set("headerTabs");
	headerTabs.linkFilters.push("brand", "msite", "postPassword", "portal", "tempPassword");
	headerTabs.links.push(
		memberPrePasswordHomeLink,
		memberPrePasswordPayPremiumLink,
		memberPrePasswordDiscoverLink,
		memberPrePasswordShopLink,
		memberPrePasswordShopmnLink,
		memberPrePasswordShopwyLink,
		memberPrePasswordFindDoctorLink,
		memberPrePasswordLiveHealthyLink,
		memberPrePasswordWellnesswyLink,
		memberPrePasswordMedicareLink,
		memberPrePasswordMedicareMNLink,
		memberPrePasswordMedicareWYLink,
		changePasswordLink,
		memberPostPasswordHomeLink,
		memberPostPasswordMNHomeLink,
		memberPostPasswordEbillLink,
		memberPostPasswordMNMedicaidHomeLink,
		memberPostPasswordCoverageLink,
		memberPostPasswordMNMedicaidCoverageLink,
		memberPostPasswordClaimsAndSpendingLink,
		memberPostPasswordClaimsLink,
		memberPostPasswordMNMedicaidClaimsLink,
		memberPostPasswordSpendingLink,
		memberPostPasswordFindDoctorLink,
		memberPostPasswordMNMedicaidFindDoctorLink,
		memberPostPasswordPrescriptionsLink,
		memberPostPasswordMNMedicaidPrescriptionsLink,
		memberPostPasswordWellnessLink,
		memberPostPasswordMNMedicaidWellnessLink,
		memberPostPasswordNDFormsResourcesLink
	);

	var headerExtraLinks = navigation.set("headerExtraLinks");
	headerExtraLinks.links.push(memberPostPasswordAccountLink, memberPrePasswordLogInLink, memberPrePasswordRegisterLink, memberNDPrePasswordRegisterLink);
	headerExtraLinks.linkFilters.push("brand", "msite", "postPassword", "portal", "tempPassword");

	var footerLinks = navigation.set("footerLinks");
	footerLinks.linkFilters.push("brand", "msite", "postPassword", "portal", "tempPassword");
	footerLinks.links.push(
		memberPostPasswordEbillLink,
		memberPrePasswordPayPremiumLink,
		memberPrePasswordDiscoverLink,
		memberPrePasswordShopLink,
		memberPrePasswordShopmnLink,
		memberPrePasswordCustomerServicendLink,
		memberPrePasswordPrimaryPolicyndLink,
		memberPrePasswordShopwyLink,
		memberPrePasswordAdditionalLink,
		memberPrePasswordFindDoctorLink,
		memberPrePasswordLiveHealthyLink,
		memberPrePasswordWellnesswyLink,
		memberPrePasswordMedicareLink,
		memberPrePasswordMedicareMNLink,
		memberPrePasswordMedicareWYLink,
		memberPrePasswordndNoSurprisesActLink,
		memberPostPasswordCoverageLink,
		memberPostPasswordMNMedicaidCoverageLink,
		memberPostPasswordClaimsAndSpendingLink,
		memberPostPasswordClaimsLink,
		memberPostPasswordMNMedicaidClaimsLink,
		memberPostPasswordSpendingLink,
		memberPostPasswordFindDoctorLink,
		memberPostPasswordMNMedicaidFindDoctorLink,
		memberPostPasswordPrescriptionsLink,
		memberPostPasswordMNMedicaidPrescriptionsLink,
		memberPostPasswordWellnessLink,
		memberPostPasswordMNMedicaidWellnessLink,
		memberPostPasswordNDFormsResourcesLink,
		memberPostPasswordAccountLink,
		memberPostPasswordCustomersLink,
		memberPostPasswordMembersLink
	);
	var brand = brand.current.sharedBrandCode;
	if (brand.toLowerCase() == "ndbcbs") {
		footerLinks.links.splice(footerLinks.links.indexOf(memberPrePasswordAdditionalLink), 1);
	}

	hook.register('eBusinessSessionStart', ["$cookies", "qualtrics", "teamsite", "brand", "services", "$q", "sessionData", "brandConfig", "$interval", "session", "appConfig", "$state", function ($cookies, qualtrics, teamsite, brand, services, $q, sessionData, brandConfig, $interval, session, appConfig, $state) {
		if ($cookies.get('mobileUser') == "true") {
			// bv keep alive is only for desktop portal login.  mSite window stays open and manages it's own keepalive
			$interval.cancel(session.keepAlivePromise);
		}

		// user is logging in for the first time, lets update their brand based on the brand cookie
		// this is mostly important for mbh, as prepassword brand is 'pp', but post password brands vary by partner
		// FIXME: below line is unstable, branding override needs to be separated out from multi-branded plan partner configs
		brand.override = brand.override || $cookies.get('umsBrand');
		brandConfig.update();

		// TODO, clean up the entire qualtrics process, kill off the qualtrics supplied code and just run our own.
		qualtrics.lazyloadMBH();


		if (sessionData.basicInfo.role.toLowerCase() === "member") {
			//FIXME: Brand redirect needs to be re-done to return all cookies on redirect, so session can be started.
			// Until then, stop the session start, and allow URL router to sync to the state (which will call login again).
			if ((session.isBrandRedirect() && session.brandRedirectComplete !== true)
				|| (session.isInboundSSO() && session.inboundSsoComplete !== true)) {
				return $q.reject({ endSession: true });
			}

			return $q.all({
				'memberInfo': services.rbsmbl.memberInfo().fetch(),
				'volatileMemberInfo': services.rbsmbl.volatileMemberInfo().fetch(),
				'preEffectuatedValues': services.rbsmbl.preEffectuatedService().fetch()
			}).then(function (responses) {
				sessionData.memberInfo = angular.copy(responses.memberInfo.data.payload);
				sessionData.tempPassword = responses.volatileMemberInfo.data.payload
					&& responses.volatileMemberInfo.data.payload.isTempPassword
					&& !responses.volatileMemberInfo.data.payload.isCsrUser;
				sessionData.vendorDetails = [];
				sessionData.preEffectuatedValues = angular.copy(responses.preEffectuatedValues.data.payload);


				//sessionData.appConfigPreEffectuated = sessionData && sessionData.appConfig && sessionData.appConfig.LANDING && sessionData.appConfig.LANDING.SHOW_PRE_EFFECTUATED_EXPERIENCE && sessionData.appConfig.LANDING.SHOW_PRE_EFFECTUATED_EXPERIENCE.booleanValue;


				/*ND_WELLNESS*/

				var username = sessionData.memberInfo.userName;
				var postData = {
					"brand": sessionData.memberInfo.brand,
					"memberQualifierInfo": {
						"clientNumber": sessionData.memberInfo.clientList[0].clientNumber,
						"groupNumber": sessionData.memberInfo.clientList[0].groupList[0].groupNumber,
						"qualifierList": [
							"webMDRewardsIndicator",
							"rxCarveOutVendor",
							"wellnessProgramsIndicator",
							"wellnessProgramsOptInOutIndicator"
						]
					}
				};
				services.rbsmbl.memberService().getData(postData, username).then(function (response) {

					nd_wellnessProgramsIndicator = response.data.payload.qualifierInfo.wellnessProgramsIndicator;

					if (brand.current.sharedBrandCode.toLowerCase() === "ndbcbs" && nd_wellnessProgramsIndicator === "true") {

						headerTabs.links.push(memberPostPasswordWellnessLinkND);
						//RF804196/CR00810807 - Changes for Wellness tab display issue - updating the header links again to add wellness tab
						navigation.update();
						memberPostPasswordWellnessLinkND.filters.push(function () {
							if (sessionData.isBlueExtraBasic || sessionData.blueEdgeDentalIndv) {
								return false;
							}
							return true;
						});
					} else {
						memberPostPasswordWellnessLink.filters.push(function () {
							// For IBC, Wellness link hidden for blueExtraPlus
							// blueEdgeDental also hides Wellness link
							if (sessionData.isBlueExtraBasic || sessionData.blueEdgeDentalIndv) {
								return false;
							}
							return true;
						});
					}
				});
				var preEffectuatedBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'ms', 'hmbcbsde', 'pp'];
				if ((preEffectuatedBrands.indexOf(sessionData.memberInfo.brand.toLowerCase()) > -1)) {
					sessionData.preEffectuatedValues['preEffectuatedBrandFlag'] = true;
				}
				var currentPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(sessionData.memberInfo);

				var clientNumber;
				angular.forEach(sessionData.memberInfo.clientList, function (client) {
					var found = false;
					angular.forEach(client.groupList, function (group) {
						if (group.groupNumber === currentPlan.groupNumber) {
							clientNumber = client.clientNumber;
							return found = true;
						}
					});

					if (found) {
						return;
					}
				});
				var theDate = new Date().getFullYear() + "-12-31";

				// need to set a new qualifier for DPP and MDPP.
				services.rbsmbl.eligibility().getData().then(function (objSuccessResponse) {
					objSuccessResponse.data.payload.dppIndicator;
					if ((objSuccessResponse.data.payload.dppIndicator === "MA") || (objSuccessResponse.data.payload.dppIndicator === "C"))
						teamsite.setQualifier('dppIndicator', objSuccessResponse.data.payload.dppIndicator);
				});

				services.rbsmbl.vendorDetails().getVendorDetails(clientNumber, theDate, currentPlan.groupNumber).then(function (response) {
					var vendorDetails = (response
						&& response.data
						&& response.data.payload)
						? response.data.payload : [];
					sessionData.vendorDetails = vendorDetails;
				}, function (error) {
					sessionData.vendorDetails = []
				});
				/*services.rbsmbl.accountList().getData(sessionData.memberInfo.umi).then(function(response){
					var hasAccountList = response.data.payload.spendingVendor.accountListCount? true:false;
					sessionData.mnHasSpendingAccount = hasAccountList;
					navigation.update();
				}, function(){
					sessionData.mnHasSpendingAccount = false;
				});*/

				if (sessionData.memberInfo) {
					// Copy in session variables calculated in memberInfo
					angular.extend(sessionData, services.rbsmbl.memberInfo().getSessionData());

					// Set up teamsite qualifiers
					var spendingAccountExistsIndicator = 'false';
					if (services.rbsmbl.memberInfo().spendingAccountClients().length > 0) {
						spendingAccountExistsIndicator = 'true';
					}

					teamsite.setQualifier('spendingAccountExistsIndicator', spendingAccountExistsIndicator);
					teamsite.setQualifier('relationship', services.rbsmbl.memberInfo().currentMember().relationship);

					teamsite.setQualifier('relationship', services.rbsmbl.memberInfo().currentMember().relationship);
					// if (window.ContextHub) {
					// 	if (services.rbsmbl.memberInfo().currentMember().relationship == "Subscriber") {
					// 		// ContextHub.setItem("profile", $.extend(ContextHub.getItem("profile"), {memberInfo: {isSubscriber: true}}));
					// 		// ContextHub.getStore("profile").setItem("", $.extend({}, ContextHub.getItem("profile"), {memberInfo: {isSubscriber: true}}));
					// 	}
					// }

					teamsite.setQualifier('bdcIndicator', sessionData.bdcIndicator);
					teamsite.setQualifier('bdcPlusIndicator', sessionData.bdcPlusIndicator);
					teamsite.setQualifier('bdtcIndicator', sessionData.bdtcIndicator);
					teamsite.setQualifier('valueBasedBenefits', sessionData.hasVBB);
					teamsite.setQualifier('directPayIndicator', sessionData.directPayIndicator);
					teamsite.setQualifier('PBM', sessionData.pharmacyBenefitProviderIndicator);
					// If password was issued on a temporary bases, set a flag that forces all routes to redirect to the change password page

					if (sessionData.tempPassword) {
						if ($state.current.name !== "changePassword") {
							var params = {};
							// If member logged in from a state that has a redirect on login, pass the redirect URL to
							// the change password page so the user will be properly redirected after password change.
							if ($state.current.data && $state.current.data.loginRedirect) {
								params.loginRedirect = $state.current.data.loginRedirect;
							}
							// for campaign SSOs
							if ($state.current.data && $state.current.data.newWindow) {
								params.newWindow = $state.current.data.newWindow;
							}
							$state.go("changePassword", params);
						}
					}
				}
				return appConfig.getAll().then(function (appConfigResponse) {
					sessionData.appConfig = angular.extend({}, appConfigResponse);
				});
			});
		}
	}]);
	hook.register('eBusinessSessionEnd', ["$cookies", "teamsite", "brand", "services", "$q", "sessionData", "brandConfig", "$interval", "session", "appConfig", "$http", "appId",
		function ($cookies, teamsite, brand, services, $q, sessionData, brandConfig, $interval, session, appConfig, $http, appId) {
			// Reserved for future use
			// code here runs when members log out

			sessionData.siteOutage = {
				isActive: false,
				displayMsg: true,
				addnlMessage: ""
			};

			//TODO: UPDATE: currently only checking site outage for member pre-password (CHMHOM, CHMPVD).
			if (['CHMHOM', 'CHMPVD'].indexOf(appId.toUpperCase()) != -1) {

				// Check if there is a site outage for pre-password pages
				var newSiteOutageConfig = (sessionData && sessionData.appConfig && sessionData.appConfig.MEMBER_UI && sessionData.appConfig.MEMBER_UI.GLOBAL_OUTAGE) ? sessionData.appConfig.MEMBER_UI.GLOBAL_OUTAGE : {};
				var oldSiteOutageConfig = (sessionData && sessionData.appConfig && sessionData.appConfig.MEMBER_UI && sessionData.appConfig.MEMBER_UI.USE_OLD_SITE_OUTAGE) ? sessionData.appConfig.MEMBER_UI.USE_OLD_SITE_OUTAGE : {};

				var processOutageDetails = function (configDetails) {
					if (configDetails && configDetails.length > 0) {
						var outageDetails = {};
						try {
							outageDetails = JSON.parse(configDetails)[appId.toUpperCase()];
							angular.extend(sessionData.siteOutage, outageDetails);
						} catch (error) {
							outageDetails = {};
						}
					}
				}

				// Old site outage logic can be removed once SPLASH re-write is complete.
				if (oldSiteOutageConfig && oldSiteOutageConfig.booleanValue === true) {
					processOutageDetails(oldSiteOutageConfig.overrideValue);
					// See if home.html is present, url is set in the appConfig overrideValue by AppID.
					$http.get(sessionData.siteOutage.oldOutageURL).then(function (response) {
						sessionData.siteOutage.isActive = false;
						navigation.update();
					}, function (response) {
						sessionData.siteOutage.isActive = true;
						navigation.update();
					});

				} else if (newSiteOutageConfig && newSiteOutageConfig.booleanValue === true) {
					sessionData.siteOutage.isActive = newSiteOutageConfig.booleanValue;
					processOutageDetails(newSiteOutageConfig.overrideValue);
				}
			}

		}
	]);
}]);
